module.exports = __webpack_public_path__ + "img/mail.47983718.svg";